<template>
	<v-card>
		<v-card-title>Send Message</v-card-title>
		<v-card-text>
			<v-select placeholder="Message type" v-model="messageType" :items="options" item-text="text" item-value="value"></v-select>
			<div v-if="messageType == 'templateMessage'">
				<ExternalTemplateMessage v-on:validate="validate" :otherParams="templateMessagingParams" :recipients="to" v-on:batch="batchMessages"></ExternalTemplateMessage>
			</div>
			<v-textarea 
			v-if="messageType == 'longMessage' || messageType == 'short'" 
			v-model="messageContent" 
			:counter="messageType == 'short' ? 360 : false"
			label="Message Content"></v-textarea>
			<small class="red--text" v-if="messageContent.length > 360 && messageType == 'short'"> Message text over the character limit will be truncated </small>
		</v-card-text>
		<v-card-actions class="pb-4 pl-4">
			<v-btn right color="red" dark @click="$emit('cancel')">Cancel</v-btn>
			<v-btn color="primary" dark  @click="send" :disabled="!valid">Send</v-btn>
		</v-card-actions>
	</v-card>
</template>
<script>
	import Vuex from 'vuex';
	import ExternalTemplateMessage from "../tools/ExternalTemplateMessage"

	export default {
		name: "SendCustomMessage", 
		props: {
			anonymous: {type: Boolean},
			from: {type: String}, 
			to: {type: Array}, 
			templateMessagingParams: { type: Object }
		},
		data: () => {
			return {
				messageContent: '',
				messageType: false,
				valid: false, 
				batch: []
			}
		},
		components: {
			ExternalTemplateMessage: ExternalTemplateMessage
		},
		computed: {
			...Vuex.mapState({
				user: state => state.auth.user,
				view: state => state.auth.view
			}),
			isBatch(){
				return this.contactEvents.length > 1
			},
			contactEvents() {
				const self = this;
				var events = [];
				if( self.messageType == "templateMessage" ){
					events = self.batch;
				}
				else{
					if( self.messageType == "short" ) {
						self.messageContent = self.messageContent.substr(0,359);
					}
					self.to.forEach( function(to){
						let contactEvent = {
							direction: "outbound",
							recipient: to, 
							sender: self.from, 
							content: self.messageContent,
							fromAddress: self.sendFrom,
						}
						if( self.anonymous ){
							contactEvent.type = 'anonymousMessage'; 
						} 
						else{
							contactEvent.type = 'customMessage'; 
						}

						contactEvent.channel = self.messageType == 'short' ? 'sms' : 'email';
						events.push( contactEvent )
					})
				}
				events.forEach( e => {
					e.messageType = self.messageType;
					e.sendStatus = "unsent";
				})
				return events;
			},
			sendFrom: function(){
				if( !this.anonymous ){
					return this.user.email;
				}
				if( !this.from ){ return; }
				return this.from + "@m.works";
			}, 
			options(){
				let options = [
					{'text':'Send email', 'value': 'longMessage'}, 
					// {'text':'Send message', 'value': 'short'} 
				]
				
				if( this.view == 'client' && this.to.length == 1){
					// options.push( {'text':'Send from my own email client', 'value': 'ownEmail'} )
				}
				if( this.view == 'admin' ){
					options.push(
						{'text': "Send template", "value": "templateMessage"}
					)
				}
				return options;
			}
		},
		methods: {
			validate(valid){
				this.valid = valid;
			},
			batchMessages(events){
				this.batch = events;
			},
			send: function(){
				const self = this;
				if( self.messageType == 'ownEmail' ){
					let href = 'mailto:'+ self.to[0] + "@m.works";
					window.open(href, '_blank');
					self.$emit("cancel")
				}
				else{
					if( self.isBatch ){
						self.$store.dispatch("addDoc", {
							collection: "contactBatches",
							data: {
								messageType: self.messageType,
								author: self.user.uid,
							}
						}).then( (ref) => {
							var batchId = ref.id;
							self.contactEvents.forEach( message => {
								message.batch = batchId;
								self.$store.dispatch("addDoc", {
									collection: "contactEvents",
									data: message
								}).then( () => {
									self.$emit("sent", "Message sent")
								}).catch( () => {
									self.$emit("sent", "Message not sent. Please contact administrator")
								} )
							
							} )
						})
					}
					else{

						self.contactEvents.forEach( message => {
							self.$store.dispatch("addDoc", {
								collection: "contactEvents",
								data: message
							}).then( () => {
								self.$emit("sent", "Message sent")
							}).catch( (   ) => {
								self.$emit("sent", "Message not sent. Please contact administrator")
							} )
						
						} )
					}
				}
			}
		},
		watch: {
			messageType(t){
				if( !t || t == 'templateMessage' ){
					this.valid = false;
				}
				else{
					this.valid = true;
				}
			}
		}

	}
</script>